module.exports = __webpack_public_path__ + "img/IMG_2200.9d0d81d5.jpg";